import { AGRONOMY_PAYMENT_TERMS_OPTIONS } from 'appConstants';
import type { IValidationField } from 'hooks/useValidations/types';
import { getFixedT } from 'i18next';
import * as yup from 'yup';

export default function agreementPaymentTerms({ label = '' }: IValidationField) {
  const t = getFixedT(null, 'CreateAgronomyAgreement', 'CustomerDetails');

  return yup
    .string()
    .label(label)
    .nullable()
    .default('')
    .required(t('errors.required'))
    .oneOf(
      AGRONOMY_PAYMENT_TERMS_OPTIONS.map(({ value }) => value),
      t('errors.required'),
    );
}
